import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';

import { INQUIRY_TEMPLATE_EDITOR_FORM_NAME } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/constants';
import { SelectStyleInput } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorStyleSections/inputs';
import { StyleValueFontWeight } from 'lib/inquiryStyles';

/**
 *  Deriving keys from enums returns both the string and number index of each entry
 *  For example, getting the keys of:
 *
 *  enum Foo {
 *    Bar = 'bar'
 * }
 *
 * will result in [0, 'Bar']
 */
const FontWeightOptions = Object.entries(StyleValueFontWeight)
  .filter(([name, _]) => typeof name !== 'number')
  .map(([name, value]) => ({
    label: name,
    value,
  }));

const FONT_WEIGHT = 'font-weight';

type FontWeightSelectProps = {
  editable: boolean;
  path: string;
  defaultValue?: StyleValueFontWeight;
};

const FontWeightSelect = ({ editable, path, defaultValue }: FontWeightSelectProps) => {
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (value: StyleValueFontWeight) => {
      dispatch(change(INQUIRY_TEMPLATE_EDITOR_FORM_NAME, `${path}.${FONT_WEIGHT}`, value));
    },
    [path, dispatch],
  );

  return (
    <SelectStyleInput
      name={`font-weight-select-${path}`}
      editable={editable}
      defaultValue={defaultValue as string}
      label='Font weight'
      placeholder='Select a font weight'
      field={FONT_WEIGHT}
      options={FontWeightOptions}
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      onChange={handleChange}
    />
  );
};

export default FontWeightSelect;
